<template>
  <div v-if="preguntas.length > 0" oncopy="return false">
    <div v-if="terminado != 0">
      <h3 class="center">Diagnóstico terminado.</h3>
      <respuestaC />
    </div>
    <div v-if="preguntas.length > 0 && terminado == 0">
      <!-- <b> Cuestionario </b> <br /> -->
      <blockquote v-if="letrero == 1">
        <p>
          Este examen contiene 40 reactivos de opción múltiple divididos en
          cuatro secciones:
          <i
            >1) Sondeo, 2) Teoría tecnopedagógica, 3) Conocimiento y experiencia
            en el uso de nuevas tecnologías aplicadas a la educación y 4)
            Nociones básicas de metodología de investigación.</i
          >
          En la primera sección, el sondeo, no hay respuestas correctas o
          incorrectas; para las tres secciones restantes sí las hay.
        </p>

        <p>
          La finalidad de este diagnóstico es conocer, tanto a nivel individual
          como grupal, información general de los candidatos y sus conocimientos
          previos en temas centrales para el curso de esta maestría. Su carácter
          no es punitivo ni selectivo, es decir, su resultado no determina el
          ingreso al programa académico. La información recabada permitirá al
          ILCE, además de conocer un poco a sus futuros estudiantes, ofrecerles
          una retroalimentación que pudiera inducir o reforzar estos conceptos
          básicos.
        </p>

        <p>
          Contarás con 45 minutos para responder; al enviar tus respuestas
          recibirás retroalimentación, y podrás imprimir o descargar tus
          resultados y las lecturas básicas seleccionadas para reforzar o
          adentrarse en temas fundamentales.
        </p>
      </blockquote>
      <p>
        <!-- <i class="material-icons">format_list_bulleted</i> -->

        <button v-if="inicio == 0" class="btn" @click="cronometro()">
          Iniciar cuestionario
        </button>
      </p>
      <div v-if="inicio > 0">
        <blockquote v-if="letrero == 1">
          <b>PRIMERA SECCIÓN: SONDEO</b>
        </blockquote>
        <blockquote v-if="letrero == 2">
          <b>SEGUNDA SECCIÓN: TEORÍA TECNOPEDAGÓGICA (15 PREGUNTAS)</b>
        </blockquote>
        <blockquote v-if="letrero == 3">
          <b
            >TERCERA SECCIÓN: CONOCIMIENTO Y EXPERIENCIA EN EL USO DE NUEVAS
            TECNOLOGÍAS APLICADAS A LA EDUCACIÓN (15 PREGUNTAS)</b
          >
        </blockquote>
        <blockquote v-if="letrero == 4">
          <b
            >CUARTA SECCIÓN: NOCIONES BÁSICAS DE METODOLOGÍA DE INVESTIGACIÓN
            (10 PREGUNTAS)</b
          >
        </blockquote>
        <div class="fixed-action-btn top">
          <p class="tiempo">Tiempo restante</p>
          <div class="caja">
            <span class="cronometro" id="cronometro">{{ this.result }}</span>
          </div>
        </div>
        <div v-for="items in preguntasPreguntas" :key="items.id">
          <p
            style="user-select: none"
            class="pregunta textopregunta"
            v-show="(items < posterior && items >= preg) || vari == 'total'"
          >
            <b>Pregunta {{ preguntas[items].pregunta1.pregunta }}</b>
          </p>
          <div
            class="cuestionario parrafo"
            v-for="item in preguntas[items].pregunta1.respuestas"
            :key="item.id"
          >
            <p v-show="(items < posterior && items >= preg) || vari == 'total'">
              <label>
                <input
                  :name="`grupo${items}`"
                  type="radio"
                  @click="opcion(item, items)"
                  :value="item"
                  v-model="respuestas[items]"
                />
                <span class="letrapreg" style="user-select: none">{{
                  item
                }}</span>
              </label>
            </p>
          </div>
        </div>
        <p v-if="vari == ''" class="warning">Todos los campos son requeridos</p>
        <button class="btn" @click="sig" v-if="vari == 'sig'">Siguiente</button>
        <button class="btn" @click="enviar" v-if="vari == 'total'">
          Enviar respuestas del cuestionario
        </button>
        <br />
        <br />
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert";
import axios from "axios";
import respuestaC from "./respuesta_c.vue";

window.oncontextmenu = function () {
  return false;
};
export default {
  components: { respuestaC },
  data() {
    return {
      preguntasPreguntas: [],
      preguntas: [],
      preg: 0,
      respuestas: [],
      vari: "",
      posterior: 8,
      result: 0,
      time: 2700,
      cuenta: 0,
      mostrar: false,
      letrero: 1,
      inicio: 0,
      anuncio: "",
      terminado: 0,
      bandera: 0,
    };
  },
  methods: {
    cambiar() {
      this.mostrar = !this.mostrar;
      console.log("lo hace");
    },
    reset() {
      this.mostrar = false;
    },
    sig() {
      console.log("preg " + this.preg + " posterior " + this.posterior);

      if (this.preg == 38) {
        this.preg += 10;
        // this.posterior += 10;
      }
      if (this.preg == 23) {
        this.preg += 15;
        this.posterior += 15;
      }
      if (this.preg == 8) {
        this.preg += 15;
        this.posterior += 15;
      }
      if (this.preg == 0) {
        // console.log("entro");
        this.preg += 8;
        this.posterior += 15;
      }

      this.vari = "";
      window.scrollTo(0, 0);
      // console.log("Total de respuetas" + this.respuestas.length);
      if (this.respuestas.length == this.cuenta) {
        console.log("Entra");
        this.vari = "total";
      }
      this.letrero++;
      // if (this.respuestas.length == 16 && this.posterior >= 24) {
      //   this.vari = "total";
      // }
    },
    opcion(item, items) {
      this.respuestas[items] = item;
      let totll = 0;
      this.respuestas.forEach((item) => {
        if (item != "") {
          totll++;
        }
      });
      console.log("total" + totll);
      if (this.preg == 0) {
        if (totll % 8 == 0) {
          this.vari = "sig";
        }
      }
      if (this.preg == 8) {
        if (totll % 23 == 0) {
          this.vari = "sig";
        }
      }
      if (this.preg == 23) {
        if (totll % 38 == 0) {
          this.vari = "sig";
        }
      }
      // if (this.preg == 38) {
      //   if (totll % 48 == 0) {
      //     this.vari = "sig";
      //   }
      // }
      if (totll % this.cuenta == 0) {
        if (this.bandera != 0) {
          this.vari = "total";
        }
        if (this.bandera == 0) {
          this.vari = "sig";
          this.bandera++;
        }
      }
    },
    async enviar() {
      let total = 0;
      let x = this.preguntasPreguntas.length;
      const numero = 10 / x;

      this.preguntas.forEach((item, index) => {
        item.pregunta1.seleccion = this.respuestas[index];
      });
      let original = this.preguntas;
      original.forEach((item, index) => {
        item.pregunta1.respuestal =
          item.pregunta1.respuestas[item.pregunta1.correcta];
        item.pregunta1.seleccion = this.respuestas[index];

        if (item.pregunta1.correcta == item.pregunta1.seleccion) {
          item.pregunta1.puntuacionobtenida = numero;
          total += numero;
        } else {
          item.pregunta1.puntuacionobtenida = 0;
          total += 0;
        }
        // console.log("Numero " + numero + " Toltal " + total);
      });
      let fechas = new Date();
      // console.log(fechas);
      let fecha = `${fechas.getDate()}/${
        fechas.getMonth() + 1
      }/${fechas.getFullYear()}`;
      let preguntas = {
        // preguntas: this.preguntas,
        preguntas: original,
        // dispocicion: this.preguntas,
        fecha_respuesta: fecha,
        total: total.toFixed(2),
        tipo: "evaluacion",
        tiempo: this.time,
        anuncio: this.anuncio,
      };
      let mo = this.respuestas[4].substring(2);
      let datosTabla = {
        genero: this.respuestas[0] == "A) H" ? "H" : "M",
        nacionalidad:
          this.respuestas[1] == "A) HONDUREÑA" ? "HONDUREÑA" : "MEXICANA",
        labora: this.respuestas[2] == "A) SI" ? 1 : 0,
        modalidad: mo,
      };
      // console.log(datosTabla);
      // console.log(preguntas.preguntas[0].seleccion);
      let datosG = new FormData();
      let datosCuestionario = JSON.stringify(preguntas);
      let datosTabla2 = JSON.stringify(datosTabla);

      datosG.append("id_pros", this.$store.state.datosC.id_pros);
      datosG.append("cuestionario", datosCuestionario);
      datosG.append("datosTabla", datosTabla2);

      let k;
      try {
        k = await axios.post(
          this.$store.state.url + "actualizarCuestionario.php",
          datosG
        );
        console.log(k.data);
        if (k.data == true) {
          swal("", "Se guardaron los datos correctamente", "success");
          this.terminado = 1;
        }
        if (k.data != true) {
          swal("", "Ha ocurrido un error intentalo de nuevo", "error");
        }
      } catch (error) {
        console.log(error);
      }
    },
    cronometro() {
      this.inicio = 1;
      // var hours = Math.floor(this.time / 3600);
      var minutes = Math.floor((this.time % 3600) / 60);
      var seconds = this.time % 60;

      //Anteponiendo un 0 a los minutos si son menos de 10
      minutes = minutes < 10 ? "0" + minutes : minutes;

      //Anteponiendo un 0 a los segundos si son menos de 10
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var result = minutes + ":" + seconds;

      if (this.time > 0) {
        this.time--;

        setTimeout(() => {
          this.cronometro();
        }, 1000);
      }
      if (this.time == 0) {
        // sweet : Puedes continuar con tu evaluación pero se ha excedido el tiempo
        //Actualizar en la base de datos
        this.anuncio =
          "Puedes continuar con tu evaluación pero se ha excedido el tiempo";
        swal(
          "",
          "Puedes continuar con tu evaluación pero se ha excedido el tiempo",
          "warning"
        );
        // this.enviar();
      }

      this.result = result;
    },
    async mostrarCuestionario() {
      let x;
      try {
        x = await require("../assets/json/cuestionario.json");
        this.preguntas = x.preguntas;

        // let variable = "A) George Siemens";
        // console.log(x.preguntas[8].pregunta1.retro.respuesta[variable]);
        // console.log(x.preguntas);
        this.original = x.preguntas;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    M.AutoInit();
    await this.mostrarCuestionario();

    // this.cronometro();
  },
  async created() {
    await this.mostrarCuestionario();

    // this.preguntas = this.$store.state.mcuestionario;
    let x = this.preguntas.length;
    this.cuenta = x;
    console.log("c" + this.cuenta);
    for (let index = 0; index < x; index++) {
      this.preguntasPreguntas.push(index);
    }
    let y = this.$store.state.datosC.cuestionario;
    // console.log("Esto es y " + y);
    // console.log(this.$store.state.datosC.cuestionario);

    // if (this.$store.state.datosC.cuestionario == null) {
    //   this.terminado = 0;
    // }
    if (y != null) {
      this.terminado = 1;
    }
  },
};
</script>
<style scoped>
.warning {
  color: goldenrod;
}
.letrapreg {
  color: black;
  font-size: 20px;
}
</style>
